import { defineStore } from 'pinia'
import { ref } from 'vue'
import Api from 'src/api/carbody'

/**
 * Small store holding the CarBody "pending products" badge count (navbar,
 * item 6 — new products awaiting send + pending update proposals). Refreshed
 * once on `AppDrawer.vue` mount (permission-gated) and again after any
 * action that actually moves the count (batch create, pending delete, update
 * proposal create/delete).
 */
export const useCarBodyPendingCountStore = defineStore(
  'carbody-pending-count',
  () => {
    const count = ref(0)
    const newCount = ref(0)
    const updatesCount = ref(0)
    const loaded = ref(false)

    async function fetch(): Promise<void> {
      try {
        const response = await Api.pendingProductsCount()
        count.value = response.data.count
        newCount.value = response.data.new
        updatesCount.value = response.data.updates
        loaded.value = true
      } catch (er) {
        // Badge is best-effort — a failed fetch just leaves the previous count.
        void er
      }
    }

    return {
      count,
      newCount,
      updatesCount,
      loaded,
      fetch,
    }
  }
)
